import { render, staticRenderFns } from "./PreviewAffiliatesButtonElement.vue?vue&type=template&id=554679e2&"
import script from "./PreviewAffiliatesButtonElement.vue?vue&type=script&lang=js&"
export * from "./PreviewAffiliatesButtonElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports